
function Hr() {
  return (
    <hr />
  )
}

export default Hr